export interface SimpleAcceptOrderRequest {
  id: number
  collectionNo: string
  acceptDate: string
  _reserveAssign?: boolean
}

export function SimpleAcceptOrderRequestToJSON(
  value: SimpleAcceptOrderRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    accept_date: value.acceptDate !== '' ? value.acceptDate : undefined,
    _reserve_assign: value._reserveAssign ?? undefined
  }
}
